import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScrollService {
  private scrollDirection = new BehaviorSubject<string>('down');
  scrollDirection$ = this.scrollDirection.asObservable();

  updateScrollDirection(direction: string) {
    this.scrollDirection.next(direction);
  }
}
